import WebIM from '../libs/webIM';
import * as myStore from '../store/myStore';
import * as types from '../constants/actionTypes';
import * as loginActions from './loginActions';

const _utils = require('../sdks/src/utils').utils;

import * as storageHelper from '../functions/storageHelper';
import { TIMEOUT_TRY_RECONNECT_NOW, SESSIONS } from '../constants/constants';

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

let timeoutOpen: NodeJS.Timeout | null = null;

function getStore() {
  return myStore.getStore();
}

function getloginReducer() {
  return getStore().getState().loginReducer;
}

export function updateConnectionStatusSuccess(currentConnectionStatus: string) {
  return { type: types.UPDATE_CONNECTION_STATUS, currentConnectionStatus };
}

export function attempToConnectSuccess(isReconnecting: boolean) {
  return { type: types.ATTEMPT_CONNECT_SUCCESS, isReconnecting };
}

export function toggleDisableReconnectingLabel(disableReconnectingLabel: boolean) {
  return { type: types.TOGGLE_DISABLE_RECONNECTING_LABEL, disableReconnectingLabel };
}

interface OptionConnect {
  apiUrl?: string;
  user?: string;
  pwd?: string;
  accessToken?: string;
  appKey?: string;
  resource?: string;
}

export function tryConnectNow(isClose = true, optionConnect?: OptionConnect) {
  let sessionJIdResource = '';
  let jIdRes = '';

  const xmppUserName = getloginReducer().userName && getloginReducer().userName.trim().toLowerCase();
  const xmppPassword = getloginReducer().password;

  if (!isNative) {
    // sessionJIdResource = storageHelper.getKey(SESSIONS.JID_RESOURCE);
    // jIdRes = sessionJIdResource ? xmppUserName + sessionJIdResource : '';
  } else {
    jIdRes = getloginReducer().jIdResource;
  }

  if (!jIdRes) {
    if (WebIM.config.isMultiLoginSessions) {
      sessionJIdResource = _utils.generateJidResource();
    }
    jIdRes = xmppUserName + sessionJIdResource;
    if (!isNative && storageHelper.storageCachingSupported()) {
      storageHelper.setKey(SESSIONS.JID_RESOURCE, sessionJIdResource);
      getStore().dispatch(loginActions.updateFromUserJid(sessionJIdResource)); // fix storageHelper.getKey(CONSTS.SESSIONS.JID_RESOURCE) change when user open multi tab on desktop version
    }
  }

  if (isClose) {
    if (!WebIM.conn.isClosed() && !WebIM.conn.isClosing()) {
      WebIM.conn.close('logout');
    }
  }

  if (!timeoutOpen) {
    timeoutOpen = setTimeout(
      () => {
        clearTimeout(timeoutOpen!);
        timeoutOpen = null;
        WebIM.conn.resetReconnectNumTotal();
        const option = optionConnect || {
          apiUrl: WebIM.config.apiURL,
          user: xmppUserName,
          pwd: xmppPassword,
          accessToken: xmppPassword,
          appKey: WebIM.config.appkey,
          resource: jIdRes,
        };
        WebIM.conn.open(option);
      },
      optionConnect ? 1000 : TIMEOUT_TRY_RECONNECT_NOW
    );
  }
  return () => {};
}
